/**
 * Loads the signed-in athlete's player card: saved options, includeQrCode,
 * hasCard, availableOptions and cardData (every available item, with scores).
 */
export const getPlayerCard = async (apiInstance) => {
  const response = await apiInstance.get("/athlete/player-card");
  return response.data;
};

/**
 * Saves the signed-in athlete's player card choices and the card PNG.
 * Returns the saved card (same body as getPlayerCard), including token and imageUrl.
 */
export const savePlayerCard = async (
  apiInstance,
  { options, includeQrCode, imageData },
) => {
  const response = await apiInstance.put("/athlete/player-card", {
    options,
    includeQrCode,
    imageData,
  });
  return response.data;
};

/**
 * Clears the signed-in athlete's player card. Shared card links then show the
 * "no longer has a card" banner.
 */
export const clearPlayerCard = async (apiInstance) => {
  const response = await apiInstance.delete("/athlete/player-card");
  return response.data;
};
